import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';


@Component({
	selector: 'app-add-card',
	templateUrl: './add-card.component.html',
	styleUrls: ['./add-card.component.scss']
})
export class AddCardComponent implements OnInit {
	tap: any;
	card: any;
	cardDetail: any = {
		"tapToken": '',
		"card": '',
		"brand": ''
	}
	cardError: string;
	tapUILoaded: boolean = false;

	constructor(
		public activeModal: NgbActiveModal,
	) { }

	ngOnInit(): void {

	}

	ngAfterViewInit() {
		// this.initializeTap();
	}


	submit() {
	}

}
